/* eslint no-useless-concat: 0 */
/* eslint no-useless-concat: 0 */
/* eslint no-unused-vars: 0 */

import util from 'util';
import React, { Component } from "react";
import PageTitle from "../Theme/PageTitle/index.js";
import DashboardLayout from "../Theme/DashboardLayout/index.js";
import { Button, Col, Modal, Row, Descriptions, Collapse, Typography, Divider } from "antd";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(utc);
dayjs.extend(timezone);
import Spinner from '../Theme/Spinner/index.js';
import Widget from "../Theme/Widget/index.js";
import generateQuickScheduleView from './generateQuickScheduleArray.js';
import { bindActionCreators } from "redux";
import * as postedScheduleActions from '../../redux/actions/postedScheduleActions.js';  // TODO: remove dispatch / action from this component
import * as myQuickScheduleActions from '../../redux/actions/myQuickScheduleActions.js';  // TODO: remove dispatch / action from this component
import { makeResourceFirst } from '../../api/apiUtils.js';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getOffsetTime from '../../utils/getOffsetTime.js';
import { UPDATE_LIVE_SCHEDULE_OPTIMISTIC_RERENDER_STATUS } from '../../redux/actions/actionTypes.js';
import assignments from '../../AuthLogic/rules/assignments.js';


import lodash from 'lodash';
const { groupBy, cloneDeep } = lodash;

const { Panel } = Collapse;
const { Title, Text } = Typography;



/**
 * Displays the My Quick Schedule, a summary of 1 day schedules for the current week.
 */
class MyQuickScheduleView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      resource: {
        id: '',
        name: ''
      },
      postedSchedulesArray: [],
      tours: '',
      startDate: '',
      infoModal: false,
      listPostedSchedulesArray: '',
      loaded: false,
      dayTypesArrayJSON: []
    };
  }


  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
  }

  readyApiCall() {
    this.setState({
      resource: {
        id: this.props.user.login.resourceId,
        name: this.props.user.userDemographics.name
      }
    }, () => {
      this.getDataFromApi();
    })
  }


  // fetches the list of schedules and then each schedule
  getDataFromApi = async () => {
    await this.props.actions.fetchListMyQuickSchedules(this.state.resource.id).catch(error => {
      console.log("Loading list of posted schedules failed\n" + JSON.stringify(error));
    });

    let postedArray = [];
    let dayTypesArray = []
    let dayTypesArrayJSON = []
    let listMyQuickSchedules = await generateQuickScheduleView(this.props.listMyQuickSchedules);

    for (let i = 0; i < listMyQuickSchedules.length; i++) {
      if (listMyQuickSchedules[i].id && listMyQuickSchedules[i].id > 0) { //if it has a schedule
        await this.props.actions.fetchPostedSchedules(listMyQuickSchedules[i].startDate, 1, listMyQuickSchedules[i].id, this.state.resource.id, this.state.resource.name).catch(error => {
          console.log("Loading posted schedules failed" + JSON.stringify(error));
        });
        let schedule = makeResourceFirst(this.props.postedSchedule.postedSchedule, this.state.resource.id);
        if (schedule[0] && schedule[0].dayTypes) {
          dayTypesArray.push(Object.values(schedule[0].dayTypes));
        }
        const objJson = Object.values(this.props.postedScheduleJSON).find(el => el.rId ==this.state.resource.id);
        dayTypesArrayJSON.push(objJson);

      }
    }
    // creates an array of arrays where the inner array are matched by resource day type
    let sortedDayTypeArray = Object.values(dayTypesArray.flat().reduce((result, currentValue) => {
      (result[currentValue['rdtId']] = result[currentValue['rdtId']] || []).push(
        currentValue
        );
        return result;
      }, {}));
      
      postedArray = this.formatSchedule(sortedDayTypeArray);
      
      const myQuickScheduleJSON = this.formatScheduleJSON(dayTypesArrayJSON);
    await this.props.actions.updateMyQuickSchedulesArray(postedArray);
  
    this.setState({
      loaded: true,
      dayTypesArrayJSON: myQuickScheduleJSON
    });
  }
  //NEW
  formatScheduleJSON = (sortedDayTypeArray) => {
    if (!sortedDayTypeArray) {
      return false;
    }

    let sevenDaySchedule = [
      { order: 1, displayDate: "Today", date: dayjs().format('dddd, MMMM DD, YYYY'), tours: [], standByAssignments: [], dayOffRequests: [], dayOff: [] },
      { order: 2, displayDate: "Tomorrow", date: dayjs().add(1, 'day').format('dddd, MMMM DD, YYYY'), tours: [], standByAssignments: [], dayOffRequests: [], dayOff: [] },
      { order: 3, date: dayjs().add(2, 'day').format('dddd, MMMM DD, YYYY'), tours: [], standByAssignments: [], dayOffRequests: [], dayOff: [] },
      { order: 4, date: dayjs().add(3, 'day').format('dddd, MMMM DD, YYYY'), tours: [], standByAssignments: [], dayOffRequests: [], dayOff: [] },
      { order: 5, date: dayjs().add(4, 'day').format('dddd, MMMM DD, YYYY'), tours: [], standByAssignments: [], dayOffRequests: [], dayOff: [] },
      { order: 6, date: dayjs().add(5, 'day').format('dddd, MMMM DD, YYYY'), tours: [], standByAssignments: [], dayOffRequests: [], dayOff: [] },
      { order: 7, date: dayjs().add(6, 'day').format('dddd, MMMM DD, YYYY'), tours: [], standByAssignments: [], dayOffRequests: [], dayOff: [] },
    ];

    for(let day of sevenDaySchedule){
      for(let dayType of sortedDayTypeArray){
        if(dayType.tour) for(let tour of dayType.tour){
          if(dayjs(tour.startTime).isSame(day.date,'day')){
            if(day.tours.find(el => el.tourId==tour.tourId) == undefined){
              day.tours.push(tour)
            }
          }
        }
        if(dayType.assignments) for(let assignment of dayType.assignments){
          if(dayjs(assignment.startTime).isSame(day.date,'day')){
            if(day.standByAssignments.find(el => el.jeId ==assignment.jeId)== undefined){
              day.standByAssignments.push(assignment)
            }
          }
        }
        if(dayType.dayTypes){
          if(dayjs(dayType.startDate).utc().isSame(day.date,'day')){
            day.dayOff.push(dayType.dayTypes)
          }
        }
        if(dayType.dayOffRequest){
          if(dayjs(dayType.startDate).utc().isSame(day.date,'day')){
            day.dayOffRequests.push(dayType.dayOffRequest)
          }
        } 
      }
    }
    return sevenDaySchedule.sort((a, b) => a.order - b.order);
  }



  // manipulates the data from the 1 day schedules into a format we can display as a pseudo 7 day schedule
  formatSchedule = (sortedDayTypeArray) => {

    if (!sortedDayTypeArray) {
      return false;
    }

    let sevenDaySchedule = [
      { order: 1, displayDate: "Today", date: dayjs().format('dddd, MMMM DD, YYYY'), dayType: [], standByAssignments: [], dayOffRequests: [] },
      { order: 2, displayDate: "Tomorrow", date: dayjs().add(1, 'day').format('dddd, MMMM DD, YYYY'), dayType: [], standByAssignments: [], dayOffRequests: [] },
      { order: 3, date: dayjs().add(2, 'day').format('dddd, MMMM DD, YYYY'), dayType: [], standByAssignments: [], dayOffRequests: [] },
      { order: 4, date: dayjs().add(3, 'day').format('dddd, MMMM DD, YYYY'), dayType: [], standByAssignments: [], dayOffRequests: [] },
      { order: 5, date: dayjs().add(4, 'day').format('dddd, MMMM DD, YYYY'), dayType: [], standByAssignments: [], dayOffRequests: [] },
      { order: 6, date: dayjs().add(5, 'day').format('dddd, MMMM DD, YYYY'), dayType: [], standByAssignments: [], dayOffRequests: [] },
      { order: 7, date: dayjs().add(6, 'day').format('dddd, MMMM DD, YYYY'), dayType: [], standByAssignments: [], dayOffRequests: [] },
    ];
    
    let sortedDayTypes = [];
    for (let dayType of sortedDayTypeArray) {
      let sortedDayType = {
        rdtId: dayType[0].rdtId,
        dayTypeName: dayType[0].dayTypeName || '',
        rdtStartTime: null,
        rdtStartDate: '',
        rdtEndtime: null,
        rdtEndDate: '',
        type: '',
        standByAssignments: [],
        dayOffRequests: [],
        tours: [],
        tourMeals: [],
        tourAssignments: [], // these assignments belong to the tour and are "placed"
        daysOff: [],
      }

      for (let dayTypeObject of dayType) {
        if (dayTypeObject.assignment) {

          sortedDayType.standByAssignments.push(dayTypeObject);
          sortedDayType.type = 'assignment';

          let startObject = this.findStartTimeAndDate(sortedDayType);

          sortedDayType.rdtStartTime = startObject.startTime;
          sortedDayType.rdtStartDate = startObject.startDate;

          let endObject = this.findEndTimeAndDate(sortedDayType);
          sortedDayType.rdtEndTime = endObject.endTime;
          sortedDayType.rdtEndDate = endObject.endDate;

        } else if (dayTypeObject.tour) {

          sortedDayType.tours.push(dayTypeObject);
          sortedDayType.type = 'tour';

          let startObject = this.findStartTimeAndDate(sortedDayType)

          sortedDayType.rdtStartTime = startObject.startTime;
          sortedDayType.rdtStartDate = startObject.startDate;

          let endObject = this.findEndTimeAndDate(sortedDayType);
          sortedDayType.rdtEndTime = endObject.endTime;
          sortedDayType.rdtEndDate = endObject.endDate;

          sortedDayType.tourMeals = this.findTourMeals(sortedDayType);

          sortedDayType.tourAssignments = this.findTourAssignments(sortedDayType);


        } else if (dayTypeObject.dayOff) {

          sortedDayType.daysOff.push(dayTypeObject);
          sortedDayType.type = 'dayOff';

          let startObject = this.findStartTimeAndDate(sortedDayType)

          sortedDayType.rdtStartTime = startObject.startTime;
          sortedDayType.rdtStartDate = startObject.startDate;

          let endObject = this.findEndTimeAndDate(sortedDayType);
          sortedDayType.rdtEndTime = endObject.endTime;
          sortedDayType.rdtEndDate = endObject.endDate;

        }

        // day off request
        if (dayTypeObject.dayOffRequest) {
          if (!sortedDayType.type) {
            sortedDayType.type = 'dayOffRequest';
          }
          sortedDayType.dayOffRequests.push(dayTypeObject.dayOffRequest);

          let startObject = this.findStartTimeAndDate(sortedDayType)

          sortedDayType.rdtStartTime = startObject.startTime;
          sortedDayType.rdtStartDate = startObject.startDate;

          let endObject = this.findEndTimeAndDate(sortedDayType);
          sortedDayType.rdtEndTime = endObject.endTime;
          sortedDayType.rdtEndDate = endObject.endDate;
        }
      }

      if (sortedDayType.type) {
        sortedDayTypes.push(sortedDayType);
      }
    }

    for (let day of sevenDaySchedule) {
      for (let dayType of sortedDayTypes) {
        if (dayjs(dayType.rdtStartDate).isSame(dayjs(day.date), 'day')) {
          if (dayType.dayOffRequests && dayType.dayOffRequests.length > 0) {
            day.dayOffRequests.push(dayType);
          }
          if (dayType.standByAssignments && dayType.standByAssignments.length > 0) {// if a standby assignment
            day.standByAssignments.push(dayType);
          } else if ((dayType.tours && dayType.tours.length > 0) || (dayType.daysOff && dayType.daysOff.length > 0)) { // if either a tour or a day off
            day.dayType.push(dayType);
          }
        }
      }
    }

    sevenDaySchedule = this.filterOutIncompleteDays(sevenDaySchedule);

    return sevenDaySchedule.sort((a, b) => a.order - b.order);
  }

  findStartTimeAndDate = (rdtObject) => {
    let startObject = {
      startTime: null,
      startDate: null
    }
    switch (rdtObject.type) {
      case 'assignment':
        let startAssignmentUnix = rdtObject.standByAssignments[0].dayStart;
        let assignmentOffset = getOffsetTime(dayjs.unix(startAssignmentUnix));
        startObject.startTime = dayjs.unix(startAssignmentUnix).add(assignmentOffset, 'minute').unix();
        startObject.startDate = dayjs.unix(startAssignmentUnix).add(assignmentOffset, 'minute').format('MM/DD/YYYY');
        break;
      case 'tour':
        let tours = []
        for (let tour of rdtObject.tours) {
          tours.push(tour.tour);
        }

        let startTourUnix = tours.sort((a, b) => (a.startTime > b.startTime) ? 1 : -1)[0].startTime;
        let tourOffset = getOffsetTime(dayjs.unix(startTourUnix));
        startObject.startTime = dayjs.unix(startTourUnix).add(tourOffset, 'minute').unix()
        startObject.startDate = dayjs.unix(startTourUnix).add(tourOffset, 'minute').format('MM/DD/YYYY');

        break;
      case 'dayOff':
        let dayOffUnix = rdtObject.daysOff[0].dayOff.startTime;
        let dayOffOffset = getOffsetTime(dayjs.unix(dayOffUnix));

        startObject.startTime = dayjs.unix(dayOffUnix).add(dayOffOffset, 'minute').unix();
        startObject.startDate = dayjs.unix(dayOffUnix).add(dayOffOffset, 'minute').format('MM/DD/YYYY');

        break;
      case 'dayOffRequest':
        let dayOffRequestUnix = rdtObject.dayOffRequests[0].startTime;
        let dayOffRequestOffset = getOffsetTime(dayjs.unix(dayOffRequestUnix));

        startObject.startTime = dayjs.unix(dayOffRequestUnix).add(dayOffRequestOffset, 'minute').unix();
        startObject.startDate = dayjs.unix(dayOffRequestUnix).add(dayOffRequestOffset, 'minute').format('MM/DD/YYYY');
        break;
      default:
        break;
    }

    return startObject;
  }

  findEndTimeAndDate = (rdtObject) => {
    let endObject = {
      endTime: null,
      endDate: null
    }
    switch (rdtObject.type) {
      case 'assignment':
        let endAssignmentUnix = rdtObject.standByAssignments[0].assignment.mqsEndTime;
        let assignmentOffset = getOffsetTime(dayjs.unix(endAssignmentUnix));
        endObject.endTime = dayjs.unix(endAssignmentUnix).add(assignmentOffset, 'minute').unix();
        endObject.endDate = dayjs.unix(endAssignmentUnix).add(assignmentOffset, 'minute').format('MM/DD/YYYY');
        break;
      case 'tour':
        let tours = []
        for (let tour of rdtObject.tours) {
          tours.push(tour.tour);
        }

        let startTourUnix = tours.sort((a, b) => (a.startTime > b.startTime) ? 1 : -1)[0].startTime; // using duration and start time to calculate end time
        let tourOffset = getOffsetTime(dayjs.unix(startTourUnix));
        let duration = rdtObject.tours[0].tour.duration;
        endObject.endTime = dayjs.unix(startTourUnix).add(duration, 'hour').add(tourOffset, 'minute').unix();
        endObject.endDate = dayjs.unix(endObject.endTime).format("MM/DD/YYYY");

        break;
      case 'dayOff':
        let dayOffUnix = rdtObject.daysOff[0].dayOff.startTime; // days off are all day so we are using the start time
        let dayOffOffset = getOffsetTime(dayjs.unix(dayOffUnix));

        endObject.endTime = dayjs.unix(dayOffUnix).add(dayOffOffset, 'minute').unix();
        endObject.endDate = dayjs.unix(dayOffUnix).add(dayOffOffset, 'minute').format('MM/DD/YYYY');
        break;
      case 'dayOffRequest':
        let dayOffRequestUnix = rdtObject.dayOffRequests[0].startTime;
        let dayOffRequestOffset = getOffsetTime(dayjs.unix(dayOffRequestUnix));

        endObject.endTime = dayjs.unix(dayOffRequestUnix).add(dayOffRequestOffset, 'minute').unix();
        endObject.endDate = dayjs.unix(dayOffRequestUnix).add(dayOffRequestOffset, 'minute').format('MM/DD/YYYY');
        break;
      default:
        break;
    }

    return endObject;
  }

  findTourMeals = (rdtObject) => {
    let meals = [];
    for (let tour of rdtObject.tours) {
      if (tour.tour.meal) {
        let formattedMeal = {}
        const meal = tour.tour.meal;
        const parsedMealStartTime = meal.mealTime;
        const parsedMealEndTime = meal.mealEndTime;
        const offset = getOffsetTime(dayjs.unix(parsedMealStartTime));
        const mealTimeFormatted = dayjs.unix(parsedMealStartTime).add(offset, 'minute').format();
        const mealEndTimeFormatted = dayjs.unix(parsedMealEndTime).add(offset, 'minute').format();

        formattedMeal.mealStartTime = mealTimeFormatted;
        formattedMeal.mealEndTime = mealEndTimeFormatted;
        meals.push(formattedMeal);
      }
    }
    return meals;
  }

  findTourAssignments = (rdtObject) => {
    let assignments = []
    for (let tour of rdtObject.tours) {
      if (tour.tour.assignments) {
        let assignmentObjectArray = Object.values(tour.tour.assignments);
        for (let assignment of assignmentObjectArray) {
          assignments.push(assignment);
        }
      }
    }
    // creates an array of arrays where the inner array are matched by job element id
    return Object.values(assignments.flat().reduce((result, currentValue) => {
      (result[currentValue['jeId']] = result[currentValue['jeId']] || []).push(
        currentValue
      );
      return result;
    }, {}));
  }

  formatDisplayText = (rdtObject, index) => {
    if (rdtObject && rdtObject.dayType && rdtObject.dayType.length > 0 && rdtObject.dayType[0].tours && rdtObject.dayType[0].tours.length > 0) {
      return this.formatTourText(rdtObject.dayType[0], index);
    } else if (rdtObject && rdtObject.dayType && rdtObject.dayType.length > 0 && rdtObject.dayType[0].daysOff && rdtObject.dayType[0].daysOff.length > 0) {
      return this.formatDayOffText(rdtObject.dayType[0]);
    } else return '';
  }
//NEW
  formatDisplayTextJSON = (schedule, index) => {
    const sortByStartDate = (arr) =>{
      return arr.sort((a,b) =>{
        return new Date(a.startDate) - new Date(b.startDate);
      });
    };
    const sortByStartTime = (arr) =>{
      return arr.sort((a,b) =>{
        return new Date(a.startTime) - new Date(b.startTime);
      });
    };
    const findCoincidence = (arr,el) => {
      if (!el || !el.startTime) return null;
      const startDate = new Date (el.startTime);
      for (const item of arr){
        const itemStartDate = new Date (item.startTime);
        if (itemStartDate>=startDate ) {
          arr.splice(arr.indexOf(item),1);
          return item;
        }
      }
      return null;
    }
    if(!schedule) return
    let {tours, standByAssignments, dayOffRequests, dayOff} = schedule
    let toursToDisplay = ((tours || []).filter(f=>dayjs(f.startTime).isSame(schedule.date,'day')) || []).map(item=>({
      ...item, kind:"tour"
    }));
    
    let standByAssignmentsToDisplay = ((standByAssignments|| []).filter(f=>dayjs(f.startTime).isSame(schedule.date,'day')) || []).map(item=>({
      ...item, kind:"standByAssignment"
    }));

    toursToDisplay.forEach(t=>{
      if(t.assignments == null) 
        t.assignments=[];
      let assignments = t.assignments.map(item=>({...item,kind:"assignment"}))
      let el = null
      do {
        el = findCoincidence(standByAssignmentsToDisplay,t);
        if (el) assignments.push(el);
      } while (el)
      let meals = (t.meal|| []).map(item=>({...item,kind:"meal"}));
      
      let listToDisplay= sortByStartTime(assignments.concat(meals));
      t.listToDisplay = listToDisplay;
    });

    let displayList = sortByStartTime((toursToDisplay).concat(standByAssignmentsToDisplay));

    // if(dayOff.length > 0) return <p key={index} style={{ marginBottom: 5 }}>{dayOff[0][0].dayTypeName}</p> //If DayTypes(DayOff)
    return (
      <React.Fragment>
        {
          dayOff.length > 0 ? <p key={index} style={{ marginBottom: 5 }}><b>{dayOff[0][0].dayTypeName}</b></p> : null //If DayTypes(DayOff)
        }
        {displayList.length>0 ? 
          displayList.map(item=>{
            if (item.kind=="tour"){
              return (
                <React.Fragment key={item.tourId}>
                  <p style={{ marginBottom: 5 }}><b>{`${dayjs(item.startTime).format('h:mma')}-${dayjs(item.endTime).format('h:mma')}${dayjs(item.startTime).add(1,'day').isBefore(item.endTime) ? '+': ''}`}</b></p>
                  {
                    item.listToDisplay && item.listToDisplay.map(l=>{
                      if (l.kind=="assignment") {
                        return (
                          <p key={l.jeId} style={{ marginBottom: 5 }}>
                            {`${dayjs(l.startTime).format('h:mma')}-${dayjs(l.endTime).format('h:mma')} ${l.serviceName}`}
                          </p>
                        )
                      } else if (l.kind == "meal") {
                        return <p key={l.mealId} style={{ marginBottom: 5, color:'black', backgroundColor: '#A9D08E', width:'fit-content', padding: '0 1px' }}>{`${dayjs(l.startTime).format('h:mma')}-${dayjs(l.endTime).format('h:mma')} Meal`}</p>
                      } else if(l.kind=="standByAssignment") {
                        return (
                          <React.Fragment key={l.jeId}>
                            <p style={{ marginBottom: 5 }}><mark>{`${dayjs(l.startTime).format('h:mma')}-${dayjs(l.endTime).format('h:mma')} ${l.serviceName}`}</mark></p>
                          </React.Fragment>
                        );
                      }  else
                        return;
                    })
                  }
                  
                </React.Fragment>
              )
            } else if(item.kind=="standByAssignment") {
              return (
                <React.Fragment key={item.jeId}>
                  <p style={{ marginBottom: 5 }}><mark>{`${dayjs(item.startTime).format('h:mma')}-${dayjs(item.endTime).format('h:mma')} ${item.serviceName}`}</mark></p>
                </React.Fragment>
              );
            } else
              return
          }) : null}

        {dayOffRequests.length > 0 ? 
          dayOffRequests.map(dor => {
            return dor.map(d => <p key={d.dorId} style={{ marginBottom: 5 }}><mark><b>{d.dayTypeName}</b></mark></p>)
          })
        : null}

      </React.Fragment>
      )
  }

  filterOutIncompleteDays = (dayList) => {
    for (let day of dayList) {
      let filteredRdtId;
      if (day && day.dayType && day.dayType.length > 1) { // check which day type has the later start time
        let daysByRdtId = Object.values(groupBy(day.dayType, "rdtId"));
        filteredRdtId = daysByRdtId.reduce((a, b) => {
          return a[0].rdtStartTime > b[0].rdtStartTime ? a[0].rdtId : b[0].rdtId;
        })
      }
      if (filteredRdtId) {
        day.dayType = day.dayType.filter((rdtDay) => rdtDay.rdtId === filteredRdtId);
      }
    }
    return dayList;
  }

  tourHeaderEdgeCases = (tour, index) => {
    const tourStart = dayjs.unix(tour.rdtStartTime)
    const midnightDayEdgeCase = tourStart.hours() === 0 && tourStart.minutes() < 5;
    const durationOver24EdgeCase = tour && tour.tours[0] && tour.tours[0].tour && tour.tours[0].tour.duration >= 24;

    if (midnightDayEdgeCase && durationOver24EdgeCase) {
      return '*+';
    } else if (midnightDayEdgeCase && !durationOver24EdgeCase) {
      return '*';
    } else if (!midnightDayEdgeCase && durationOver24EdgeCase) {
      return '+';
    } else return '';
  }

  formatTourText = (tour, index) => { 
    const tourStart = dayjs.unix(tour.rdtStartTime)
    const assignments = cloneDeep(tour.tourAssignments);

    let sortedAssignments  = assignments.sort((a, b) => {
      return a[0].startTime - b[0].startTime;
    }); 

    let meal;
    let mealUnix;
    let mealIndex = 0;
    if (tour && tour.tourMeals && tour.tourMeals[0]) {
      meal = cloneDeep(tour.tourMeals[0]);
      mealUnix = dayjs(meal.mealStartTime).unix();

      for (let index = 0; index < sortedAssignments.length; index++) {
        if (mealUnix > dayjs.unix(sortedAssignments[index][0].startTime).add(getOffsetTime(dayjs.unix(sortedAssignments[index][0].startTime)), 'minute').unix()) {
          mealIndex = index + 1;
        }
      }
    }
    return (
      <React.Fragment>
        <p style={{ marginBottom: 5 }}><b>{tourStart.format('h:mma') + ' - ' + dayjs.unix(tour.rdtEndTime).format('h:mma') + this.tourHeaderEdgeCases(tour, index)}</b></p>

        {(meal && mealUnix && mealIndex === 0) &&
          <p style={{ marginBottom: 5 }}>{dayjs.unix(mealUnix).format("h:mma") + ' - ' + dayjs(meal.mealEndTime).format("h:mma") + ' Meal'}</p>
        }

        {
          sortedAssignments.map((assignment, index) => (
            <React.Fragment key={index}>

              {(meal && mealUnix && mealIndex === index && mealIndex !== 0 && mealIndex !== sortedAssignments.length) &&
                <p style={{ marginBottom: 5 }}>{dayjs.unix(mealUnix).format("h:mma") + ' - ' + dayjs(meal.mealEndTime).format("h:mma") + ' Meal'}</p>
              }

              {/* needed to add offset here, was throwing error elsewhere */}
              {/* need to check if the if the tour is a standby assignment associated with a tour */}
              {assignment[0].jeStatus == 10 ?
                (
                  <p style={{ marginBottom: 5 }}><mark>
                    {this.formatAssignmentText(tour, assignment[0])}
                  </mark></p>
                )
                :
                (
                  <p style={{ marginBottom: 5 }}>
                    {this.formatAssignmentText(tour, assignment[0])}
                  </p>
                )
              }
            </React.Fragment>
          ))
        }

        {(meal && mealUnix && mealIndex !== 0 && mealIndex === sortedAssignments.length) &&
          <p style={{ marginBottom: 5 }}>{dayjs.unix(mealUnix).format("h:mma") + ' - ' + dayjs(meal.mealEndTime).format("h:mma") + ' Meal'}</p>
        }

      </React.Fragment >
    )
  }

  formatDayOffText = (dayOff) => {
    return (
      <p style={{ marginBottom: 5 }}>{dayOff.dayTypeName}</p>
    )
  }

  formatAssignmentText = (tour, assignment) => {
    let date = '';
    const offset = getOffsetTime(dayjs.unix(assignment.startTime));
    if (tour && tour.rdtStartDate) {
      if (!dayjs(tour.rdtStartDate).isSame(dayjs.unix(assignment.startTime).add(offset, 'minute'), 'day')) {
        date = dayjs.unix(assignment.startTime).add(offset, 'minute').format('(M/D) ');
      }
    }
    const timeAndService = date + dayjs.unix(assignment.startTime).add(offset, 'minute').format("h:mma") + ' - ' + dayjs.unix(assignment.endTime).add(getOffsetTime(dayjs.unix(assignment.endTime)), 'minute').format("h:mma") + ' ' + assignment.service;
    return timeAndService;
  }

  formatStandbyAssignmentText = (tour, assignment) => {
    let date = '';
    if (tour && tour.date) {
      if (!dayjs(tour.date).isSame(dayjs.unix(assignment.rdtStartTime), 'day')) {
        date = dayjs.unix(assignment.rdtStartTime).format('(M/D) ');
      }
    }
    const timeAndService = date + dayjs.unix(assignment.rdtStartTime).format("h:mma") + ' - ' + dayjs.unix(assignment.rdtEndTime).format("h:mma") + ' ' + assignment.standByAssignments[0].assignment.service;
    return timeAndService
  }

  // currently unused but still useful
  returnTypeText = (day) => {
    if (day && day.dayType && day.dayType.length > 0) {
      switch (day.dayType[0].type) {
        case 'tour':
          return 'Tour';
        case 'dayOff':
          return 'Day Off';
        default:
          return '';
      }
    } else if (day && day.standByAssignments && day.standByAssignments.length > 0) {
      return 'Stand-by Assignments';
    }
    return 'No data found for this day';
  }

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  handleModalClick = (e) => {
    this.setState({
      infoModal: true
    });
  }

  handleModalCancel = (e) => {
    this.setState({
      infoModal: false,
    });
  }

  render() {
    if (this.state.loaded && this.props.myQuickSchedulesArray.length > 0) {
      return (
        <DashboardLayout>
          <PageTitle title={'My Quick Schedule'}
            subTitle={this.state.resource.name || this.props.user.userDemographics.name} />

          <Modal
            zIndex={2000}
            title={'About this view'}
            open={this.state.infoModal}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[]}
          >
            <p>This view consolidates the tours and assignments for users based on all available posted 1-day schedules. For teams using only 7-day or 9-day posted schedules, this screen may be empty or inaccurate. </p>
            <p>This feature is still being tested and certified. Please double check your daily schedules and report any inconsistencies you may find to the STORM product team.</p>
          </Modal>
          <Button type="primary" block onClick={this.handleModalClick}>About this view</Button>

          <Widget>
            <Title level={1}>{this.state.resource.name || this.props.user.userDemographics.name}</Title>
            {this.state.dayTypesArrayJSON.map((schedule, index) => (
              <div key={schedule.order} style={{ marginBottom: 35 }}>
                {schedule.displayDate ?
                  (
                    <React.Fragment>
                      <Title level={3} style={{ marginTop: 5, marginBottom: 5 }}>{schedule.displayDate ? schedule.displayDate : ''}</Title>
                      <Title level={3} style={{ marginTop: 5, marginBottom: 5 }}>{schedule.date ? schedule.date : ''}</Title>
                    </React.Fragment>
                  )
                  :
                  (
                    <React.Fragment>
                      <Title level={3} style={{ marginTop: 5, marginBottom: 5 }}>{schedule.date ? schedule.date : ''}</Title>
                    </React.Fragment>
                  )}
                {(schedule.tours && schedule.tours.length > 0) || (schedule.standByAssignments && schedule.standByAssignments.length > 0) || (schedule.dayOffRequests && schedule.dayOffRequests.length > 0) || (schedule.dayOff && schedule.dayOff.length > 0) ? (
                  <Text>
                    {this.formatDisplayTextJSON(schedule, index)}
                  </Text>
                )
                  :
                  (
                    <p style={{fontSize:"small"}}>
                      No data found for this day
                    </p>
                  )}

              </div>
            ))
            }
          </Widget >

          <Widget>
            <Title level={2}>Legend</Title>
            <Text>
              {/* <p><b>*</b> = My Quick Schedule cannot certify the start time or end time of a tour crossing over midnight or starting at midnight of a schedule.</p> */}
              <p><b>+</b> = This tour is over 24 hours long. Please confirm your tour and assignment times directly in your available posted schedules.</p>
              <p><mark>Standby Assignment or Unapproved Day Type Request</mark></p>
              <p style={{color:'black', backgroundColor: '#A9D08E', width:'fit-content', padding: '0 1px'}}>Meal Time</p>
            </Text>
          </Widget>
        </DashboardLayout >
      )
    } else if (this.state.loaded && this.props.myQuickSchedulesArray.length <= 0) {
      return (
        <DashboardLayout>
          <Widget>
            <PageTitle title={'No available posted 1-day schedules'} />
            <Modal
              zIndex={2000}
              title={'About this view'}
              open={this.state.infoModal}
              onCancel={this.handleModalCancel} // the x in top right corner
              footer={[]}
            >
              This view consolidates the tours and assignments for users based on all available posted 1-day schedules. For teams using only 7-day or 9-day posted schedules, this screen may be empty or inaccurate.
            </Modal>
            <Button type="primary" block onClick={this.handleModalClick}>About this view</Button>
          </Widget>
        </DashboardLayout>
      )
    } else {
      return <Spinner />
    }
  }
}

MyQuickScheduleView.propTypes = {
  actions: PropTypes.object.isRequired,
  // postedSchedule: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user,
    listMyQuickSchedules: state.listMyQuickSchedules,
    postedSchedule: state.postedSchedules,
    postedScheduleJSON: state.postedSchedulesJSON,
    myQuickSchedulesArray: state.myQuickSchedulesArray
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchListMyQuickSchedules: bindActionCreators(
        myQuickScheduleActions.fetchListMyQuickSchedules,
        dispatch
      ),
      fetchPostedSchedules: bindActionCreators(
        postedScheduleActions.fetchPostedSchedules,
        dispatch
      ),
      updateMyQuickSchedulesArray: bindActionCreators(
        myQuickScheduleActions.updateMyQuickSchedulesArray,
        dispatch
      )
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyQuickScheduleView);